<aside>
  <h2>Settings</h2>

  <nav aria-label="Settings sections">
    @for (item of navItems(); track item.key) {
      <button
        tuiButton
        appearance="flat-grayscale"
        size="s"
        [iconStart]="item.icon"
        type="button"
        [tuiAppearanceState]="activeSection() === item.key ? 'hover' : null"
        (click)="navigateTo(item.key)"
      >
        {{ item.label }}
      </button>
    }
  </nav>
</aside>

<main>
  <header class="page-header" [class.page-header--subpage]="isSubpage()">
    <div class="page-header__copy">
      <h1>{{ headerTitle() }}</h1>
      <p>{{ headerDescription() }}</p>
    </div>

    @if (!isSubpage() && activeItem().actionLabel) {
      <button
        tuiButton
        type="button"
        size="s"
        [iconStart]="activeItem().actionIcon || null"
        (click)="runHeaderAction()"
      >
        {{ activeItem().actionLabel }}
      </button>
    }
  </header>

  <section class="section-content">
    @switch (visibleSection()) {
      @case ('account') {
        @defer {
          <app-settings-account />
        }
      }
      @case ('company') {
        @defer {
          <app-settings-company />
        }
      }
      @case ('users-roles') {
        @defer {
          @if (isUsersRolesList()) {
            <app-settings-users-roles
              [activeTab]="usersRolesTab()"
              (tabChange)="changeUsersRolesTab($event)"
              (addUser)="openUserForm(null)"
              (editUser)="openUserForm($event)"
              (addRole)="openRoleForm(null)"
              (editRole)="openRoleForm($event)"
              (copyRole)="openRoleForm($event, true)"
            />
          } @else if (isUserFormView()) {
            <app-settings-user-form
              [userId]="editingUserId()"
              (cancelled)="backToUsersRolesList()"
              (saved)="backToUsersRolesList()"
            />
          } @else {
            <app-settings-role-form
              [roleId]="editingRoleId()"
              [copy]="copyingRole()"
              (cancelled)="backToUsersRolesList()"
              (saved)="backToUsersRolesList()"
            />
          }
        }
      }
      @case ('subscriptions') {
        @defer {
          <app-settings-subscriptions />
        }
      }
      @case ('plans') {
        @defer {
          <app-settings-plans />
        }
      }
      @case ('billing') {
        @defer {
          <app-settings-billing />
        }
      }
      @case ('privacy-security') {
        @defer {
          <app-settings-privacy-security />
        }
      }
      @case ('integrations') {
        @defer {
          <app-settings-integrations />
        }
      }
      @case ('regional-settings') {
        @defer {
          <app-settings-regional />
        }
      }
      @case ('tags') {
        @defer {
          <app-settings-tags />
        }
      }
      @case ('manage-files') {
        @defer {
          <app-settings-manage-files />
        }
      }
    }
  </section>
</main>
